import React, { memo, useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';

const OsDonutChart = memo(({ linkId, title, organizationId, userId }) => {

    const [loading, setLoading] = useState(false);
    const [series, setSeries] = useState([]);
    const [options, setOptions] = useState({
        chart: {
            type: 'donut',
        },
        labels: ['Windows', 'Linux', 'MacOS', 'Android', 'Other'],
        colors: ['#43E5A0', '#00A383', '#144EE3', '#144EE361', '#EB568E'],
        stroke: {
            width: 0
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        total: {
                            label: 'clicks and scans',
                            show: true,
                            color: 'var(--secondary-text)',
                            fontSize: 12,
                        },
                        value: {
                            color: 'var(--black)',
                            fontWeight: 'bold'
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: true,
            horizontalAlign: 'center', floating: true,
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: true
            },
        }, responsive: [
            {
                breakpoint: 640,
                options: {
                    legend: {
                        floating: false,
                        position: "bottom"
                    }
                }
            }
        ]
    });

    async function getChartData() {
        setLoading(true);
        let tempSeries = [];
        let tempLabel = [];
        let resp = await getApi(urlApi.operatingSystemDonutChartData + userId + "/" + organizationId + "/" + linkId);
        if (resp.responseCode === 200) {
            for (const item of resp?.data) {
                tempSeries.push(item?.count ?? 0);
                tempLabel.push(item?.name ?? "Unknown");
            }
            setSeries(tempSeries);
            setOptions(prevOptions => ({
                ...prevOptions,
                labels: tempLabel
            }));
        } else {
            setSeries([0, 0, 0, 0, 0]);
            setOptions(prevOptions => ({
                ...prevOptions,
                labels: ['Windows', 'Linux', 'MacOS', 'Android', 'Other']
            }));
        }
        setLoading(false);
    }

    useEffect(() => {
        getChartData();
        return () => {

        };
    }, [linkId, userId, organizationId]);

    return (
        <div className='bg-gray-100 p-1.5 rounded-xl h-full'>
            <div className="flex justify-between items-center p-1 gap-2">
                <p className='mb-0 text-md font-bold text-[var(--grey)]'>{`${title ?? "Scan"} by operating system`}</p>
                <div className='flex ms-auto gap-2'>
                </div>
            </div>
            {loading ? "Loading..." : <Chart options={options} series={series} height={200} width={"100%"} type="donut" />}
        </div>
    )
})

export default OsDonutChart;